import { Routes } from '@angular/router';

import { privateRouteGuard } from '@guards/private-route.guard';
import { projectContentWriteGuard } from '@guards/project-content-write.guard';

/**
 * Upgrade routes nested under a project:
 *  /project/:projectId/upgrade/add         → create new upgrade item
 *  /project/:projectId/upgrade/:id         → edit existing upgrade item
 *  /project/:projectId/upgrade-types       → manage upgrade categories & collections
 */
export const UPGRADE_ROUTES: Routes = [
  {
    path: 'project/:projectId/upgrade',
    children: [
      {
        path: '',
        redirectTo: 'add',
        pathMatch: 'full',
      },
      {
        path: ':id',
        loadComponent: () =>
          import('@pages/project-details/upgrade-upsert/upgrade-upsert.component').then(
            (c) => c.UpgradeUpsertComponent,
          ),
        data: { layout: 'private' },
      },
    ],
    data: { layout: 'private' },
    // FEC-1225: add / edit forms are closed to the read-only Developer Viewer.
    canActivate: [privateRouteGuard, projectContentWriteGuard],
  },
  {
    path: 'project/:projectId/upgrade-types',
    loadComponent: () =>
      import('@pages/project-details/upgrade-type-upsert/upgrade-type-upsert.component').then(
        (c) => c.UpgradeTypeUpsertComponent,
      ),
    data: { layout: 'private' },
    canActivate: [privateRouteGuard, projectContentWriteGuard],
  },
];
